import CourseInformation from './CourseInformation';

export default CourseInformation;
